import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { SidenavUtils } from '@/common/utils/SideNavUtils';

const gtnSideNav = {
  id: 'gtn',
  shortName: 'GTN',
  displayName: 'Gross to Net',
  role: 'GTN_VIEW',
  icon: fas.faFunnelDollar,
  precedence: 3,
  route: '/gtn',
  children: [
    // Organization Menu
    SidenavUtils.orgMenu('gtn'),

    // Common Menus
    ...SidenavUtils.commonMenus('gtn')
  ]
};

export default gtnSideNav;
